module.exports = __webpack_public_path__ + "img/dingzhi_icon_shouji.087e18d3.svg";